(function () {
    if (window.__oneDriveMessagePatchApplied) return;
    window.__oneDriveMessagePatchApplied = true;

    window.addEventListener(
        "message",
        function (e) {
            try {
                const isObject = e && e.data !== null && typeof e.data === "object";
                const isExtension = typeof e.origin === "string" && e.origin.startsWith("chrome-extension://");
                if (isObject && isExtension) e.stopImmediatePropagation();
            } catch (_) { }
        },
        true
    );

    const originalAddEventListener = window.addEventListener.bind(window);

    window.addEventListener = function (type, listener, options) {
        if (type !== "message" || typeof listener !== "function") {
            return originalAddEventListener(type, listener, options);
        }

        const wrappedListener = function (event) {
            try {
                const data = event && event.data;
                const isObject = data !== null && typeof data === "object";
                const isExtension = typeof event.origin === "string" && event.origin.startsWith("chrome-extension://");

                if (isObject && isExtension) {
                    const patchedEvent = Object.create(event);
                    Object.defineProperty(patchedEvent, "data", {
                        value: JSON.stringify(data),
                        configurable: true
                    });
                    return listener.call(this, patchedEvent);
                }

                return listener.call(this, event);
            } catch (_) {
                try {
                    return listener.call(this, event);
                } catch (_) {
                    return;
                }
            }
        };

        return originalAddEventListener(type, wrappedListener, options);
    };
})();

let oneDriveClientId = null;
let oneDriveDotNetHelper = null;
let currentPickerOptions = null;

window.initializeOneDrivePicker = async (dotNetRef, clientId) => {
    oneDriveDotNetHelper = dotNetRef;
    oneDriveClientId = clientId;

    try {
        await loadOneDriveScript();
    } catch (error) {
        if (oneDriveDotNetHelper) {
            try {
                await oneDriveDotNetHelper.invokeMethodAsync(
                    "HandlePickerError",
                    error?.message || "Failed to initialize OneDrive"
                );
            } catch (_) { }
        }
    }
};

function loadOneDriveScript() {
    return new Promise((resolve, reject) => {
        if (window.OneDrive) return resolve();

        if (document.getElementById("onedrive-js")) {
            const start = Date.now();
            const t = setInterval(() => {
                if (window.OneDrive) {
                    clearInterval(t);
                    resolve();
                } else if (Date.now() - start > 10000) {
                    clearInterval(t);
                    reject(new Error("OneDrive SDK timeout"));
                }
            }, 100);
            return;
        }

        const script = document.createElement("script");
        script.id = "onedrive-js";
        script.src = "https://js.live.net/v7.2/OneDrive.js";
        script.type = "text/javascript";
        script.async = true;

        script.onload = () => {
            const start = Date.now();
            const t = setInterval(() => {
                if (window.OneDrive) {
                    clearInterval(t);
                    resolve();
                } else if (Date.now() - start > 5000) {
                    clearInterval(t);
                    reject(new Error("OneDrive object not available"));
                }
            }, 50);
        };

        script.onerror = () => reject(new Error("Failed to load OneDrive script"));
        document.head.appendChild(script);
    });
}

function getMimeFromName(name) {
    if (!name) return "application/octet-stream";
    const ext = name.toLowerCase().split(".").pop();
    const map = {
        pdf: "application/pdf",
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        doc: "application/msword",
        docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        txt: "text/plain"
    };
    return map[ext] || "application/octet-stream";
}

window.openOneDrivePicker = function (allowMultiple, allowFolders) {
    if (!window.OneDrive) {
        oneDriveDotNetHelper && oneDriveDotNetHelper.invokeMethodAsync("HandlePickerError", "OneDrive SDK not loaded");
        return;
    }

    if (!oneDriveClientId) {
        oneDriveDotNetHelper && oneDriveDotNetHelper.invokeMethodAsync("HandlePickerError", "Client ID missing");
        return;
    }

    const redirectUri = window.location.origin + "/auth/onedrive";

    currentPickerOptions = {
        clientId: oneDriveClientId,
        action: "download",
        multiSelect: allowMultiple === true,
        openInNewWindow: true,
        advanced: {
            redirectUri: redirectUri,
            endpointHint: "api.onedrive.com"
        },
        success: onPickerSuccess,
        cancel: onPickerCancel,
        error: onPickerError
    };

    try {
        window.OneDrive.open(currentPickerOptions);
    } catch (e) {
        oneDriveDotNetHelper && oneDriveDotNetHelper.invokeMethodAsync("HandlePickerError", e?.message || "Failed to open picker");
    }
};

async function onPickerSuccess(response) {
    try {
        const files = response.value || [];

        if (!files.length) {
            oneDriveDotNetHelper && oneDriveDotNetHelper.invokeMethodAsync("HandleFilesSelected", []);
            return;
        }

        const processed = [];

        for (const file of files) {
            const name = file.name || "";
            const sizeBytes = file.size || 0;
            const mimeType = getMimeFromName(name);
            const downloadUrl = file["@content.downloadUrl"] || file["@microsoft.graph.downloadUrl"] || "";

            processed.push({
                id: file.id || "",
                name: name,
                mimeType: mimeType,
                sizeBytes: sizeBytes,
                downloadUrl: downloadUrl,
                isFolder: false
            });
        }

        oneDriveDotNetHelper && oneDriveDotNetHelper.invokeMethodAsync("HandleFilesSelected", processed);
    } catch (e) {
        oneDriveDotNetHelper && oneDriveDotNetHelper.invokeMethodAsync("HandlePickerError", e?.message || "OneDrive processing failed");
    }
}

function onPickerCancel() {
    oneDriveDotNetHelper && oneDriveDotNetHelper.invokeMethodAsync("HandleFilesSelected", []).catch(() => { });
}

function onPickerError(error) {
    let msg = "OneDrive picker error";
    if (typeof error === "string") msg = error;
    else if (error && error.message) msg = error.message;
    else {
        try { msg = JSON.stringify(error); } catch (_) { }
    }
    oneDriveDotNetHelper && oneDriveDotNetHelper.invokeMethodAsync("HandlePickerError", msg).catch(() => { });
}

window.cleanupOneDrivePicker = function () {
    oneDriveDotNetHelper = null;
    oneDriveClientId = null;
    currentPickerOptions = null;
};
